import { useQuery, gql, QueryResult, OperationVariables } from "@apollo/client";

export const GET_CONFIGURATION_QUERY = gql`
  query Namespace($namespace: ID!, $configKey: String) {
    namespace(namespace: $namespace) {
      name
      status
      deleted
      configuration(configKey: $configKey) {
        key
        value
      }
    }
  }
`;

export const GET_TRUSTED_RELATIONSHIPS = gql`
  query GetUser($id: ID!) {
    user(id: $id) {
      user {
        id
        type
        trustedRelationships {
          id
          opposingOrganisation {
            name
            id
          }
          trustedUser {
            id
            firstName
            lastName
          }
          userToImpersonate {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;

export function GetGridConfig(
  namespace: string,
  type: string,
): QueryResult<any, OperationVariables> {
  return useQuery(GET_CONFIGURATION_QUERY, {
    variables: {
      namespace: namespace,
      configKey: "ui-grid-" + type.toLowerCase(),
    },
  });
}
